import React from 'react';
import { Body } from 'scy/text';
import Icon from './Icon';

export default function Summary({ user = {} }) {
  const { firstname, lastname, email, mobile } = user;
  return (
    <>
      <Icon />
      <Body>
        <div>
          {firstname} {lastname}
        </div>
        <div>{email}</div>
        <div>{mobile}</div>
      </Body>
    </>
  );
}
